export default __webpack_public_path__ + "static/media/icon-under-construction.396a4fd5.svg";